module.exports = __webpack_public_path__ + "static/media/right-arrow-bars.68e318bd.svg";